module.exports = __webpack_public_path__ + "files/2bef561aed4d89dd003d8320e67e96e8.png";